module.exports = __webpack_public_path__ + "img/bingo_ball-42.a14b37c0.png";